export const MAX_VISIBLE_COLUMNS = 7;
export const VISIBLE_ROWS = 20;

export const CONTENT_FLOWS = {
  SELECTION: 'SELECTION',
  TEXT: 'TEXT',
  UPLOADING: 'UPLOADING',
  SETTING_CSV_SEPARATOR: 'SETTING_CSV_SEPARATOR',
  UPLOADING_ERROR: 'UPLOADING_ERROR',
  TEXT_FILE: 'TEXT_FILE',
  TABLE: 'TABLE'
};

export const SIDEBAR_FLOWS = {
  INPUTS: 'INPUTS',
  ORDER_DETAILS: 'ORDER_DETAILS',
  PAYMENT_DETAILS: 'PAYMENT_DETAILS'
};
